<template>
  <v-container class="home">
    <v-row>
      <v-col>
        <h2 class="text-white">Velkommen til VIGO Kodeverksbase!</h2>
        <br />
        <p class="text-white">
          Nettstedet gir en oversikt over det sentrale kodeverket som er knyttet til videregående
          opplæring. Kodeverket kommer fra Grep (Utdanningsdirektoratets læreplandatabase),
          Nasjonalt skoleregister og VIGO. Kodeverket benyttes i forbindelse med utskriving av
          dokumentasjon for gjennomført videregående opplæring, statistikk til sentrale myndigheter
          og inntak til videregående opplæring. Versjon 08/2024.
        </p>
        <br />
        <p class="text-white">
          Utfyllende informasjon om enkelte av variablene er å finne i
          <a href="http://regbok.udir.no/" target="_blank" class="text-white"
            >Registreringshåndboken</a
          >.
        </p>
        <br />
        <v-btn
          flat
          large
          class="text-white dark-bg"
          style="border: 2px solid #ffffff"
          outlined
          @click="handleProceed"
        >
          Gå videre
        </v-btn>
      </v-col>
      <v-col class="icon-col">
        <v-icon color="white" size="350">
          mdi-school
        </v-icon>
      </v-col>
    </v-row>
  </v-container>
</template>
<script setup lang="ts">
import { useRouter } from 'vue-router'
import AXIOS from '@/plugins/http-commons'

const router = useRouter()

async function handleProceed() {
  try {
    // Record user interaction in database
    await AXIOS.post('/api/user-interaction/record')

    // Navigate to list page
    router.push('list')
  } catch (error) {
    console.error('Failed to record user interaction:', error)
    // Still navigate even if recording fails
    router.push('list')
  }
}
</script>

<style lang="sass" scoped>
.home
	margin: 2em 0em

@media only screen and (min-width: 940px)
	.home
		margin: 12em 10em 0 10em

.icon-col
	display: flex
	justify-content: center
</style>
